import React, { useEffect, Fragment } from "react";

import { redirect, Route, Routes } from "react-router-dom";
import Pages404 from "./components/PageNotFound";
import { authProtectedRoutes, publicRoutes } from "./routes";
import Layout from "./components/VerticalLayout";

const App = ({ }) => {
  useEffect(() => {
    if (localStorage.getItem("lang") == "en") {
      require(`./assets/scss/theme.scss`);
    } 
    else {
      require(`./assets/scss/theme-rtl.scss`);
    }
  }, []);

  function redirect_to_home() {
    const Permissions = JSON.parse(localStorage.getItem("permissions"));
    console.log("Permissions" + permissions[0].resource);
    if (permissions[0].resource.includes("sales")) {
      return redirect("/amenities");
    } else {
      return redirect("/amenities");
    }
  }

  const rendering_checks = async (data) => {
    //return {};
    if (localStorage.getItem("token")) {
      throw redirect_to_home();
    } else {
      if (props.location.pathname != "/login") {
        localStorage.removeItem("token");
        throw redirect("/amenities");
      } else {
        return {};
      }
    }
  };

  return (
    <Routes>
      {publicRoutes.map((route, idx) => (
        <Route key={idx} {...route} loader={(d) => rendering_checks(d)} exact />
      ))}

      {authProtectedRoutes.map((route, idx) => (
        /*<Authmiddleware
              path={route.path}
              layout={VerticalLayout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              exact
            />*/

        <Route
          key={idx}
          {...route}
          element={<Layout>{route.element}</Layout>}
          loader={(d) => rendering_checks(d)}
          exact
        />
      ))}

      <Route path="*" exact={true} component={Pages404} />
    </Routes>
  );
};

export default App;
